import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl,GetDatasyncMediaOneBlockSynchronously,SyncDeleteSynchronously} from "datasync-core";
import { globals} from "../Components/Globals/Globals";
import { produce } from 'immer';
const initialState = {
  blogsItems: [],
  blogCount: 0,
  loadBlogs_result:{status: 'idle', error: null},
  deleteBlog_result:{status: 'idle', error: null},
  validateBlogs_result:{status: 'idle', error: null, stat_email:null, stat_action:null},
}

// Create an async thunk for loading blogs
export const loadBlogs = createAsyncThunk(
  'blogs/loadBlogs',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.platform_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        seek_filter_clause: ` true `, // Do not filter blogs
        table_guid: globals.datasync.pf_blogs_table_guid,
        debugging: true
      });
      if (globals.parameters.debugging)
        console.log("loadBlogs::blogs response = ",response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for deleting blogs
export const deleteBlog = createAsyncThunk(
  'blogs/deleteBlog',
  async (deletedBlogObject) => {
    try {
      console.clear()
      console.log("deletedBlogObject->", deletedBlogObject)
      //Delete blog from Remote Datasync Database
      const response = await SyncDeleteSynchronously({
        datasync_url:globals.datasync_service.url,
        data_guid: deletedBlogObject.data_guid});
      
      if (globals.parameters.debugging)
        console.log("deleteBlog->response = ",response)

      if (response.err || response.deleted_data_count !=1)
        throw(response.err)

      return response;
    } catch (error) {
      return deletedBlogObject.rejectWithValue(error.message);
    }
  }
);

const blogSlice = createSlice({
  name: 'blogs',
  initialState,
  reducers: {
    addBlog(state, action) {
      // New stat added 
      try {
        if (globals.parameters.debugging){
          console.log("addBlog: ", state.blogsItems)
          console.log("addBlog: ", state.blogCount)
          console.log("addBlog::action ->", action)  
        }
  
        state.blogCount++;
        state.blogsItems.push(action.payload);
      } catch (error) {
        console.error("Blog added but state list insertion fails !")
        alert("Echec de l'insertion du nouvel utilisateur en mémoire interne")
      }
    },

    updateBlog(state, action) {
      return produce(state, draft => {
        //Find former stat object to update
        const updatedBlogObject = draft.blogsItems.find((blog) => blog.data_guid === action.payload.data_guid)
        console.log("updateBlog: updatedBlogObject->", updatedBlogObject)
        if (updatedBlogObject) {
          //update blog in the array
          updatedBlogObject.data_blob.data_tier = action.payload.data_blob.data_tier;
        } else {
          console.error("updateBlog: Blog not found in the array");
        }
      })
    },

    revertAllBlogs(state){
      console.log("blogSlice revertAllBlogs");
      state.blogsItems = [];
      state.blogCount = 0;
      state.loadBlogs_result = {status: 'idle', error: null};
      state.deleteBlog_result = {status: 'idle', error: null};
      state.validateBlogs_result = {status: 'idle', error: null, stat_email:null, stat_action:null};
    },

    revertStatusBlogs(state){
      if (globals.parameters.debugging)
        console.log("revertStatusBlogs")

      state.deleteBlog_result = {status: 'idle', error: null};
      state.validateBlogs_result = {status: 'idle', error: null, stat_email:null, stat_action:null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadBlogs */
      .addCase(loadBlogs.pending, (state, action) => {
        state.loadBlogs_result = {status : "loading",error : null};
      })
      .addCase(loadBlogs.fulfilled, (state, action) => {
        if (action.payload.length > 0) {
          state.loadBlogs_result = {status : "succeeded",error : null};
          state.blogsItems = action.payload;
          state.blogCount= action.payload.length;
        }
        else {
          state.loadBlogs_result = {status : "succeeded",error : "No blogs found !!!"};
          state.blogsItems = [];
          state.blogCount= 0;
        }
      })
      .addCase(loadBlogs.rejected, (state, action) => {
        state.loadBlogs_result = {status : "failed",error : action.payload};
      })

      /* deleteBlog */
      .addCase(deleteBlog.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteBlog.pending")
        console.log("deleteBlog.pending -> action", action)
        state.deleteBlog_result = {status : "deleting",error : null};
      })
      .addCase(deleteBlog.fulfilled, (state,action) => {
        //Blog sucessfully deleted from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("deleteBlog.fulfilled")
        console.log("deleteBlog.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Delete blog from local state
          draft.blogsItems = draft.blogsItems.filter((blog, j) => blog.data_guid !== action.payload.data_guid)
          draft.blogCount--;

          draft.deleteBlog_result = {status : "deleted",error : null};
        })
      })
      .addCase(deleteBlog.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteBlog.rejected")
          console.log("deleteBlog.rejected -> action", action)
        state.deleteBlog_result = {status : "failed",error : action.payload};
      })
  },
});

export const { addBlog, updateBlog, revertAllBlogs, revertStatusBlogs } = blogSlice.actions;
export default blogSlice.reducer;